import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";

const Richtext = (props: ReferenciaContenido) => {

    return (
      <div style={{ marginBottom: '80px' }}>
         <RichtextDescription descripcion={props.descripcion} />
      </div>
    )
}

export default Richtext;
